module.exports = __webpack_public_path__ + "img/icon-user-color.2494c702.png";